import { makeAutoObservable } from 'mobx'
import type { DeleteDoctorDocument } from 'domain/usecases/document/delete-doctor-document'
import { UpdateDocumentStatus } from 'domain/usecases/document/update-document-status'

type Services = {
  deleteDoctorDocument: DeleteDoctorDocument
  updateDocumentStatus: UpdateDocumentStatus
}

export class DocumentService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async deleteDoctorDocument(
    params: DeleteDoctorDocument.Params
  ): Promise<DeleteDoctorDocument.Model> {
    await this.services.deleteDoctorDocument.delete(params)
  }

  async updateDocumentStatus(
    params: UpdateDocumentStatus.Params
  ): Promise<UpdateDocumentStatus.Model> {
    await this.services.updateDocumentStatus.update(params)
  }
}

export default DocumentService
